import { render, staticRenderFns } from "./UserDetailsForm.vue?vue&type=template&id=f9ce60e0&scoped=true&"
import script from "./UserDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailsForm.vue?vue&type=style&index=0&id=f9ce60e0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ce60e0",
  null
  
)

export default component.exports